import { Middleware } from "@nuxt/types";

declare module "@nuxt/types" {
  interface Context {
    host: string;
    isMobile: boolean;
    isTablet: boolean;
    isDesktop: boolean;
  }
}

const middleware: Middleware = (context) => {
  const req = context.req ?? context.ssrContext?.req;
  const isServer = process.server;
  const isCloudfrontRequest = req?.headers["X-Amz-Cf-Id"] !== undefined;

  const userAgent = isServer ? req?.headers?.["user-agent"] ?? "" : navigator.userAgent;
  context.host = isServer
    ? // Host header supplied by cloudfront. Origin supplied by traditional browser requests, but is
      // an undesired value (the private origin hostname) when in the cloud.
      // Default to public production website for prerendered pages (req is not available)
      req?.headers.host ?? req?.headers.origin ?? "www.shopltk.com"
    : // Use host to capture the port if specified in the url
      window.location.host;

  context.isMobile = isServer
    ? isCloudfrontRequest
      ? // Cloudfront sends special detection headers, but won't work on local servers
        req?.headers["Cloudfront-Is-Mobile-Viewer"] === "true"
      : // Detect based on user agent when on local server. Probably misattributes Android tablets here
        userAgent.includes("iPhone") || userAgent.includes("Android")
    : // During SPA navigation or fallback rendering
      context.$vuetify.breakpoint.xsOnly;
  context.isTablet = isServer
    ? isCloudfrontRequest
      ? // Cloudfront sends special detection headers, but won't work on local servers
        req?.headers["Cloudfront-Is-Tablet-Viewer"] === "true"
      : // Detect based on user agent when on local server. No good/simple android tablet user agents
        userAgent.includes("iPad")
    : // During SPA navigation or fallback rendering
      context.$vuetify.breakpoint.smOnly || context.$vuetify.breakpoint.mdOnly;
  // Keep simple. Desktop is not mobile or tablet
  context.isDesktop = !(context.isMobile || context.isTablet);
};

export default middleware;
